import { FC } from 'react';
import Star from '@mui/icons-material/StarOutline';
import moment from 'moment';
import { useQuery } from 'react-query';
import { getBonuses } from 'api/user';
import InfoCard from 'components/InfoCard/InfoCard';
import { Tooltip } from '@mui/material';

const BonusCard: FC = () => {
    const bonuses = useQuery('home-bonuses', getBonuses, { staleTime: 60000 });

    const data = bonuses.data;
    const bonusRatioLabel = data?.bonus_ratio ? `${Math.round(data.bonus_ratio * 100)}%` : '0%';
    const fixRateLabel = `${data?.fix_rate ?? 0}%`;
    const effectiveRateLabel = `${Math.round((data?.effective_rate ?? 0) * 100)}%${
        data?.cap_applied ? ' (ограничено правилом выкупа)' : ''
    }`;

    return (
        <InfoCard color="bg-green-600" width="w-full lg:w-1/3" loading={bonuses.isLoading}>
            <div className="flex">
                <Star className="mr-6 text-5xl lg:self-center self-start" />
                <div className="flex-1 flex-col flex flex-wrap">
                    <div className="text-base mb-2">Бонус</div>
                    <Tooltip
                        title={
                            <div className="flex flex-col">
                                <p>Бонус по показателям: {bonusRatioLabel}</p>
                                <p>Гарантированный Fix: {fixRateLabel}</p>
                                <p className="mt-2">К выплате: {effectiveRateLabel}</p>
                                <p>Дата обновления: {moment(data?.updated_at).format('DD.MM.YYYY')}</p>
                            </div>
                        }
                    >
                        <div className="flex gap-2 flex-row flex-wrap">
                            <div>AVG ABI: {data?.avg_abi ? data?.avg_abi : '—'}</div>
                            <div>AVG Entries: {data?.avg_ts_month ? data?.avg_ts_month : '—'}</div>
                            <div>Fair ROI: {data?.fair_roi ? `${data?.fair_roi}%` : '—'}</div>
                            <div>Бонус: {data?.bonus ? `${data?.bonus}$` : '—'}</div>
                        </div>
                    </Tooltip>
                </div>
            </div>
        </InfoCard>
    );
};

export default BonusCard;
